import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import globalUtils from "../../utils/globalUtils";
import ROUTES from "../../routes";
import Notification, {
  httpErrorMessage,
} from "../../components/Notification/Notification";
import { LOGIN_INACTIVITY } from "../../shared/constants";

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      console.warn("We got a rejected action!");

      if (action.payload.status === 400) {
        const message = action.payload.data.errorMessage;
        if (!message?.includes(LOGIN_INACTIVITY.LOGIN_DISABLED)) {
          Notification({
            type: "error",
            title: "Error",
            description: httpErrorMessage(action),
          });
        }
      } else if (action.payload.status === 401) {
        globalUtils.removeTokens();
        window.location.href = ROUTES.PATHS.LOGIN;
      } else if (action.payload.status !== "FETCH_ERROR") {
        Notification({
          type: "error",
          title: "Error",
          description: httpErrorMessage(action),
        });
      }
    }

    return next(action);
  };
